var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API_PATHS } from "../types/apiPaths";
import { getHeaders } from "../utils/apiUtils";
/**
 * Timeout (ms) of an upload: a 10 MB PDF on a slow link plus the antivirus scan
 * can take far longer than useOkapiKy's default; an aborted request would show
 * an error while the server may still store the file.
 */
export var STORAGE_UPLOAD_TIMEOUT_MS = 120000;
/**
 * Uploads a supporting-resource file (cover image or table-of-contents PDF).
 * The backend scans it with the antivirus before storing it; a rejection is
 * thrown as ky's HTTPError — read it with {@link getStorageUploadError}.
 */
export var uploadStorageFile = function (kyInstance, file) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, headers, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                formData.append("file", file);
                headers = __assign({}, getHeaders());
                delete headers["Content-Type"];
                return [4 /*yield*/, kyInstance.post(API_PATHS.STORAGE_UPLOAD, {
                        body: formData,
                        headers: headers,
                        timeout: STORAGE_UPLOAD_TIMEOUT_MS,
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Storage upload failed: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
var hasJsonResponse = function (error) {
    var _a;
    return typeof error === "object" &&
        error !== null &&
        "response" in error &&
        typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.json) === "function";
};
/**
 * Reads the HTTP status and the first backend error of a failed upload —
 * `{ errors: [{ type, message }] }` (antivirus, validation) or Spring's
 * `{ message }` (MIME/size checks). Without a readable JSON body only the
 * status (if any) is returned.
 */
export var getStorageUploadError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status, withStatus, body, first, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!hasJsonResponse(error))
                    return [2 /*return*/, {}];
                status = error.response.status;
                withStatus = status !== undefined ? { status: status } : {};
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, error.response.json()];
            case 2:
                body = (_c.sent());
                first = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0];
                if (first)
                    return [2 /*return*/, __assign(__assign({}, withStatus), { type: first.type, message: first.message })];
                return [2 /*return*/, __assign(__assign({}, withStatus), { message: body === null || body === void 0 ? void 0 : body.message })];
            case 3:
                _a = _c.sent();
                return [2 /*return*/, withStatus];
            case 4: return [2 /*return*/];
        }
    });
}); };
